module.exports = __webpack_public_path__ + "static/img/am10.6c58e50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/am10.jpg
// module id = BbyB
// module chunks = 1